import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MdArrowForward } from "react-icons/md";
import MdLeftDir from "../icons/MdLeftDir";
import CargoNotif from '../images/cargoNotif.png';
import { GoChevronDown, GoChevronUp } from "react-icons/go";

export default function RecentCargoSection({ cargos }) {
  const [isMobile, setIsMobile] = useState(false);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const initialCount = isMobile ? 1 : 3;

  const visibleCargos = showAll ? cargos : cargos.slice(0, initialCount);

  return (
    <div className="flex flex-col items-center gap-10 bg-white/20 justify-start h-max lg:px-5 px-5 w-full bg-opacity-45 lg:py-10 py-6">
      <p className="lg:text-[22px] text-[18px] text-special font-bold">
        اعلام بار های اخیر
      </p>

      <div className="w-full flex flex-col lg:flex-row gap-6 lg:gap-4 justify-center items-start">
      <div className="flex lg:flex-row flex-col min-w-full gap-7 justify-start py-5  max-h-[450px] overflow-y-scroll overflow-x-scroll max-w-full">
          {visibleCargos.map((cargo, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="w-full lg:min-w-[400px]"
            >
              <CardCargoInfo
                typeOfCar={cargo.typeOfCar}
                timeOfCargo={cargo.timeOfCargo}
                timeOfCreate={cargo.timeOfCreate}
                origin={cargo.origin}
                dest={cargo.dest}
              />
            </motion.div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-center w-auto lg:mr-4 cursor-pointer ">
        <button
          onClick={() => setShowAll((prev) => !prev)}
          className="flex items-center gap-2 text-special font-bold hover:text-blue-950 transition-colors"
        >
          {showAll ? "بستن" : "نمایش بیشتر"}
          {showAll ? <GoChevronUp size={20} /> : <GoChevronDown size={20} />}
        </button>
      </div>
    </div>
  );
}


function CardCargoInfo({ typeOfCar, timeOfCargo, timeOfCreate, origin, dest }) {
  return (
    <div className="rounded-[50px] hover:translate-y-1 transition duration-200 text-special 
      w-full  bg-blue_primary  h-[200px] lg:h-[290px] 
      shadow-md flex flex-col justify-between items-center 
      px-1 lg:px-2 py-6 lg:py-6">
      
      {/* header */}
      <div className="flex justify-between w-full h-max">
        <div className="flex flex-row gap-4 items-center text-gray-900 w-auto">
          <img className="w-[40px]" src={CargoNotif} />
          <p className="lg:text-[12px] text-[10px]">{typeOfCar}</p>
        </div>

        <div className="flex flex-col gap-1 w-auto ml-10 items-center">
          <div className="text-center rounded-lg w-[80px] h-[20px] py-1 bg-[#0075FF0D]">
            <p className="text-blue-950 lg:text-[10px] text-[8px]">بارگیری {timeOfCargo}</p>
          </div>
          <p className="text-[8px] text-gray-600">{timeOfCreate}</p>
        </div>
      </div>

      {/* body */}
      <div className="h-1/3 flex flex-col w-full justify-center items-center">
        <div className="flex items-center justify-between w-full px-2">
          <div className="flex items-center gap-2">
            <span className="text-gray-800 font-medium text-[16px]">{origin}</span>
            <span className="w-2 h-2 bg-black rounded-full"></span>
          </div>

          <div className="relative w-full flex-1 mx-4">
            <div className="w-full border-t-2 border-dashed border-gray-400"></div>
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <MdLeftDir />
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <span className="w-2 h-2 bg-black rounded-full"></span>
            <span className="text-gray-800 font-medium">{dest}</span>
          </div>
        </div>
      </div>

      <div className="w-full px-20">
        <button className={`w-full text-xs lg:text-[14px]  rounded-[10px] lg:h-[55px] h-[40px] bg-special text-white hover:text-special hover:bg-gray-100 border-[1px] border-special text-center lg:px-10 py-2`}>
          مشاهده جزییات
        </button>
      </div>
    </div>
  );
}
